import addDays from 'date-fns/addDays'
import Cookie from 'js-cookie'

enum Cookies {
  BTFROMDOTCOM = 'BTFROMDOTCOM',
  BTEMBEDURL = 'BTEMBEDURL'
}

function setCookies() {

  if (typeof window === 'undefined') return

  setReferrerCookie()
  setEmbedUrl()

}

function setReferrerCookie () {

  let referrerType = 'direct'

  if (window.location.search.includes('utm_source=brighttalk-')) referrerType = 'organic'
  if (document.referrer.includes('google') || document.referrer.includes('goo.gl')) referrerType = 'organic'

  if (referrerType === 'organic') {

    Cookie.set(Cookies.BTFROMDOTCOM, 'true', {
      expires: addDays(Date.now(), 1),
      secure: true,
      path: '/'
    })

  }

}

function setEmbedUrl () {

  Cookie.set(Cookies.BTEMBEDURL, window.location.href, {
    expires:addDays(Date.now(), 1),
    secure: true,
    path: '/'
  })

}

export default setCookies
